"use strict";

import vue from "vue";
import axios, { AxiosRequestConfig } from "axios";
import store from "../store";
import main from "../main";
import version from "../version";
import HfLoading from "@/components/Loading/HfLoading";
import packageJson from "../../package.json"

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers["Content-Type"] = "x-www-form-urlencoded";
axios.defaults.withCredentials = false;
const loading = new HfLoading({ scale: 5 });

export enum Enviroment {
	base = "https://fctest.hongfund.com:8501/api/",
	jzs = "https://fc.hongfund.com:8602/api/",
	production = "https://fc.hongfund.com:8601/api/",
	backup = "https://fctest.hongfund.com:8502/api/"
}

let defaultUrl: Enviroment;

console.log(process.env.VUE_APP_TITLE);

const isJzs = process.env.VUE_APP_TITLE === "jzs";

switch (process.env.VUE_APP_TITLE) {
	case "jzs":
		defaultUrl = Enviroment.jzs;
		break;
	case "production":
		defaultUrl = Enviroment.production;
		break;
	case "development":
		defaultUrl = Enviroment.base;
		break;
	default:
		defaultUrl = Enviroment.jzs;
		break;
}

let config: AxiosRequestConfig = {
	baseURL: defaultUrl,
	timeout: 60 * 1000, // Timeout
	withCredentials: false // Check cross-site Access-Control
};

// const reLoginJzs = () => {
// 	vue.axios.defaults.baseURL = Enviroment.jzs;
// 	localStorage.removeItem("loginId");
// 	localStorage.removeItem("hashPassword");
// 	localStorage.removeItem("role");
// 	localStorage.removeItem("token");
// 	main.$router.push("/login");
// }
if (isJzs) {
	const jzsBase = localStorage.getItem("jzsBase");
	if (jzsBase !== null) config.baseURL = jzsBase;
}

const _axios = axios.create(config);

let isLatest = false;

_axios.interceptors.request.use(
	async config => {
		// loading.close();
		// 测试版本更新机制
		if (process.env.NODE_ENV != "development") {
			main.$utils.sendToElectron("insiderUpdate", packageJson.version);
		}

		// Do something before request is sent
		if (config.url && !config.url.includes("invoice/import/image")) loading.load();
		config.headers["token"] = store.state.account.token;
		config.headers["version"] = version;

		const exUrl = [
			"import",
			"upload",
			"system/set/accountbookinfo",
			"details/findall",
			"close/accountbook/multi",
			"paysheetList/copy",
			"old/import/bookData",
		];
		if (
			config.url &&
			(config.url.includes("import") || config.url.includes("upload") || config.url.includes("system/set/accountbookinfo") || config.url.includes("details/findall") || config.url.includes("close/accountbook/multi") || config.url.includes("paysheetList/copy") || config.url.includes("old/import/bookData" || config.url.includes("old/import/upload")))
		) config.timeout = 60 * 60 * 1000;
		else config.timeout = 60 * 1000;
		if (store.state.accountBook.id != null && !config.url!.includes("uibot/invoice/import/list"))
			config.headers["accountBookId"] = store.state.accountBook.id;
		return config;
	},
	error => {
		// Do something with request error
		return Promise.reject(error);
	}
);

// Add a response interceptor
_axios.interceptors.response.use(
	response => {
		// Do something with response data
		loading.close();
		isLatest = true;
		return response;
	},
	error => {
		loading.close();
		// Do something with response error
		let res = error.response.data;
		switch (res.code) {
			case 888: {
				// 代码888,退出重登
				store.dispatch("logout");
				main.$router.push("/login");
				vue.utils.clearStorage();
				break;
			}
			case 666: {
				main.$utils.updateHandle("partUpdate");
				break;
			}
			case 667: {
				main.$utils.updateHandle("fullUpdate");
				break;
			}
			default: {
				if (error.response.status != 401) {
					main.$notify({
						title: "出错啦",
						message: res.message,
						type: "warning"
					});
				}
				break;
			}
		}
		return Promise.reject(error);
	}
);
vue.axios = _axios;
